// extracted by mini-css-extract-plugin
module.exports = {"termsWrapper":"Terms_termsWrapper__WL-GV","termsContainer":"Terms_termsContainer__17dgD","termsContent":"Terms_termsContent__wQxw_","checkboxTerms":"Terms_checkboxTerms___hbuU"};